module.exports = __webpack_public_path__ + "b3833b6321bf555f761afd8367891f12.svg";